import { fetchWithAuth } from './fetchWithAuth'

export async function createVenue(
  token: string,
  body: Record<string, unknown>,
): Promise<void> {
  await fetchWithAuth('/v1/venues', token, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}
